var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strong',[_vm._v(_vm._s(_vm.location.name))]),_c('br'),(_vm.lineOne.length > 0)?_c('div',[_vm._v(" "+_vm._s(_vm.lineOne)+" ")]):_vm._e(),(_vm.lineTwo.length > 0)?_c('div',[_vm._v(" "+_vm._s(_vm.lineTwo)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }